<template>
    <div
        style="background: #dc2626"
        class="absolute top-0 z-30 flex w-full flex-row items-center justify-center py-2 shadow-md sm:left-0 sm:mr-0 print:hidden"
    >
        <span class="text-sm font-medium text-white">
            There's a billing issue with your account, please contact
            <a
                href="mailto:accounts@storekit.com"
                class="underline text-white"
            >accounts@storekit.com</a>
        </span>
    </div>
</template>

<script>
export default {
    name: 'BillingIssueNotification'
};
</script>
